document.addEventListener("DOMContentLoaded", function () {

    const bottomATC = document.querySelector('.bottom-atc');
    const addToCartBtn = document.querySelector('.addToCartBtn');

    if (!bottomATC || !addToCartBtn) return;

    let isATCVisible = true;

    // Function: Adjust Floating Widgets Position
    function adjustFloatingWidgets(shouldPush) {
        // Guard clause: ensure bottomATC exists before calculating offset
        if (!bottomATC) return;

        // Klaviyo renamed its help launcher from HubLauncherWidget__FloatingWidget-sc-* to
        // .kl-hub-launcher-container, so the old selector alone found nothing and the launcher sat
        // over the right end of the sticky button on phones. Both are matched.
        const hubWidget = document.querySelector('.kl-hub-launcher-container, [class^="HubLauncherWidget__FloatingWidget-sc"]');
        const googleWidget = document.getElementById('google-merchantwidget-iframe-wrapper');

        const offset = bottomATC.offsetHeight;

        // 1. Adjust Customer Hub
        if (hubWidget) {
            if (shouldPush) {
                hubWidget.style.transform = `translateY(-${offset}px)`;
                hubWidget.style.transition = 'transform 0.3s ease-in-out';
            } else {
                hubWidget.style.transform = 'translateY(0px)';
            }
        }

        // 2. Adjust Google Merchant Widget
        if (googleWidget) {
            if (shouldPush) {
                // The Google widget baseline is translateY(30px). 
                // We subtract the ATC offset from 30 to push it upward.
                googleWidget.style.setProperty('transform', `translateY(${30 - offset}px)`, 'important');
                googleWidget.style.setProperty('transition', 'transform 0.3s ease-in-out', 'important');
            } else {
                // Reset back to our CSS override position
                googleWidget.style.setProperty('transform', 'translateY(30px)', 'important');
            }
        }
    }
    
    // Track ATC visibility 
    const observer = new IntersectionObserver((entries) => {
        // If the main button (or bundle button) is intersecting, it's visible
        if (entries[0].isIntersecting) {
            isATCVisible = true;
            // Force hide immediately if the main button is on screen
            bottomATC.classList.add('hide');
            bottomATC.classList.remove('show');
            adjustFloatingWidgets(false); // Reset widgets
        } else {
            isATCVisible = false;
        }
    }, {
        threshold: 0
    });

    observer.observe(addToCartBtn);

    // Scroll logic decides visibility
    window.addEventListener('scroll', () => {

        const atcRect = addToCartBtn.getBoundingClientRect();
        
        // Check if the bottom of the button has passed the top of the viewport
        const hasScrolledPastATC = atcRect.bottom < 0;

        if (hasScrolledPastATC && !isATCVisible) {
            bottomATC.classList.add('show');
            bottomATC.classList.remove('hide');
            adjustFloatingWidgets(true); // Push widgets up
        } else {
            bottomATC.classList.add('hide');
            bottomATC.classList.remove('show');
            adjustFloatingWidgets(false); // Reset widgets
        }
    });

    // Bundle button support
    setTimeout(() => {
        const bundlesButton = document.querySelector('.bogos-bundles-quantity-break-button-add');
        if (bundlesButton) {
            observer.observe(bundlesButton);
        }
    }, 1400);

    // Smooth scroll delegation
    const contentContainer = document.querySelector('.batc_content');

    if (contentContainer) {
        contentContainer.addEventListener('click', (event) => {
            const link = event.target.closest('a[href^="#"]');
            if (!link) return;

            const target = document.querySelector(link.getAttribute('href'));
            if (!target) return;

            event.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }

});